import { render } from "./InjuryAffirmBillEdit.vue?vue&type=template&id=2ad63c02&scoped=true"
import script from "./InjuryAffirmBillEdit.vue?vue&type=script&lang=js"
export * from "./InjuryAffirmBillEdit.vue?vue&type=script&lang=js"

import "./InjuryAffirmBillEdit.vue?vue&type=style&index=0&id=2ad63c02&scoped=true&lang=css"
import "./InjuryAffirmBillEdit.vue?vue&type=style&index=1&id=2ad63c02&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad63c02"]])

export default __exports__